import { render } from "./RemoteHandsDetails.vue?vue&type=template&id=6fc17d84&scoped=true"
import script from "./RemoteHandsDetails.vue?vue&type=script&lang=js"
export * from "./RemoteHandsDetails.vue?vue&type=script&lang=js"

import "./RemoteHandsDetails.vue?vue&type=style&index=0&id=6fc17d84&lang=css"
import "./RemoteHandsDetails.vue?vue&type=style&index=1&id=6fc17d84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc17d84"]])

export default __exports__